import { useBreakpoints } from '@monolith/legacy/modules/design-system-candidates';

import { ref, computed, ComputedRef, inject, provide } from 'vue';

export const PRODUCTS_MOBILE = 2;
export const PRODUCTS_TABLET = 3;
export const PRODUCTS_COMPACT_DESKTOP = 4;
export const PRODUCTS_DESKTOP = 5;

const TILES_PER_ROW_INJECTION_ID = Symbol('CatalogTilesPerRow');

export const useCatalogTilesPerRow = (filtersShown = ref(false)): ComputedRef<number> => {
  const injected = inject<ComputedRef<number>>(TILES_PER_ROW_INJECTION_ID);
  if (injected) {
    return injected;
  }
  const { isAboveOrEqualMd, isAboveOrEqualLg, isAboveOrEqualXl } = useBreakpoints();
  const tilesPerRow = computed(() => {
    if (isAboveOrEqualXl.value) {
      return filtersShown.value ? PRODUCTS_COMPACT_DESKTOP : PRODUCTS_DESKTOP;
    }
    if (isAboveOrEqualLg.value) {
      return filtersShown.value ? PRODUCTS_TABLET : PRODUCTS_COMPACT_DESKTOP;
    }
    if (isAboveOrEqualMd.value) {
      return PRODUCTS_TABLET;
    }
    return PRODUCTS_MOBILE;
  });
  provide(TILES_PER_ROW_INJECTION_ID, tilesPerRow);
  return tilesPerRow;
};
